import Dialog from '../shared/Dialog'
import React, { useState } from 'react'
import type { SyntheticEvent } from 'react'

interface SearchDialogLinkProps {
  html?: string
  url: string
}

const SearchDialogLink = ({ html, url }: SearchDialogLinkProps) => {
  const [opened, setOpened] = useState(false)

  return (
    <>
      <button
        className='lb-btn lb-btn-naked search-btn'
        type='button'
        onClick={toggleDialog}
        aria-haspopup='dialog'
      >
        <span>Recherche</span>
      </button>

      <Dialog
        className='top-modal'
        initialFocus='#search-input'
        onCancel={toggleDialog}
        opened={opened}
        title='Recherche'
      >
        <section>
          <form
            id='search'
            className='u-mb-4@us u-mb-8@fs'
            role='search'
            action={url}
            method='get'
          >
            <p className='field'>
              <input
                type='search'
                name='search'
                id='search-input'
                className='form-control'
                placeholder=' '
              />
              <label htmlFor='search-input'>Médaille, croix, chevalière…</label>
              <button className='c-helper c-helper--search' type='submit'>
                <span className='visually-hidden'>Rechercher</span>
              </button>
            </p>
          </form>
          {html && (
            <aside
              className='o-wrapper o-wrapper--no-space c-glide / js-glide-um'
              dangerouslySetInnerHTML={{ __html: html }}
            />
          )}
        </section>
      </Dialog>
    </>
  )

  function toggleDialog(event: SyntheticEvent) {
    event.preventDefault()
    setOpened(!opened)
  }
}

export default SearchDialogLink
